import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

import SogPage from "@/shared/ui/SogPage.vue";
import {onMounted, reactive, ref} from "vue";
import {onBeforeRouteUpdate, RouteLocationNormalized, useRoute, useRouter} from "vue-router";
import {useSpinner} from "@/shared/composables/SogSpinner";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import {SogButtonKind} from "@/shared/ui/types/SogButtonKind";
import apiStore from "@/modules/Store/api";
import StoreItem from "@/shared/model/StoreItem";
import StoreItemCardComponent from "@/modules/Store/components/StoreItemCardComponent.vue";
import {ProductType} from "@/shared/model/productType";
import {useStoreStore} from "@/modules/Store/store";
import Insurance from "@/shared/model/Insurance";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import StoreItemInsuranceCardComponent from "@/modules/Store/components/StoreItemInsuranceCardComponent.vue";
import InsuranceExportBlank, {InsuranceExportBlankStatus} from "@/shared/model/InsuranceExportBlank";
import StoreItemInsuranceExportBlankCardComponent
  from "@/modules/Store/components/StoreItemInsuranceExportBlankCardComponent.vue";
import apiInsuranceExportBlank from "@/modules/InsuranceExportBlank/api";
import {useNavigationStore} from "@/modules/Navigation/store";
import {IdType} from "@/shared/model/idType";
import {compareStrings} from "@/shared/utils/StringUtils";



export default /*@__PURE__*/_defineComponent({
  __name: 'StoreListPage',
  setup(__props) {

const _spinner = useSpinner()
const _items = reactive<StoreItem[]>([])
const _insurances = reactive<Insurance[]>([])
const _insuranceExportBlanks = reactive<InsuranceExportBlank[]>([])
const _type = ref<string | undefined>(undefined)
const _storeStore = useStoreStore()
const _router = useRouter()
const _route = useRoute();
const _navigationStore = useNavigationStore();

async function p_init(to?: RouteLocationNormalized) {
  _type.value = to?.params.type as string

  _spinner.show()
  _items.length = 0;
  if (!_type.value) {
    _storeStore.currentItem = undefined;
  }
  try {
    switch (_type.value) {
      case 'insurance':
        if (!_storeStore.currentItem) {
          _router.back()
          return
        }
        _insurances.length = 0;
        const resInsurance = await apiStore.listInsurance(_storeStore.currentItem.purchaseProductPrice, _storeStore.currentItem.grossPrice)
        if (resInsurance)
          _insurances.push(...resInsurance)
        break;
      case 'exportblank':
        _insuranceExportBlanks.length = 0;
        const resExportBlank = await apiStore.listInsuranceExportBlank()
        if (resExportBlank)
          _insuranceExportBlanks.push(...resExportBlank.sort((a, b) => compareStrings(a.blankNumber, b.blankNumber)))
        break;
      default:
        const resStore = await apiStore.listStore()
        if (resStore) {
          _items.push(...resStore)
        }
        break;
    }


  } finally {
    _spinner.hide()
  }
}

onMounted(async () => {
  const route = useRoute()
  await p_init(route)
})

onBeforeRouteUpdate(async (to) => {
  await p_init(to)
});

async function onList(item: StoreItem) {
  _storeStore.currentItem = item
  const path = "/store/list/" + (isInsurance(item) ? "insurance" : (isInsuranceExportBlank(item) ? "exportblank" : ""));
  await _router.push(path);
}

function isInsurance(item: StoreItem) {
  return item.productType === ProductType.Kzk || item.productType === ProductType.Tz || item.productType === ProductType.Zoll;
}

function isInsuranceExportBlank(item: StoreItem) {
  return item.productType === ProductType.ExportBlank;
}

async function refresh() {
  await p_init(_route);
}

async function onIncorrectlyFilledClicked(blank: InsuranceExportBlank) {
  _spinner.show()
  await apiInsuranceExportBlank.setStatus(blank.id, InsuranceExportBlankStatus.IncorrectlyFilled);
  await refresh()
  _spinner.hide()
}

async function onRemoveIncorrectlyFilledClicked(blank: InsuranceExportBlank) {
  _spinner.show()
  await apiInsuranceExportBlank.setStatus(blank.id, undefined);
  await refresh()
  _spinner.hide()
}

async function onDetailsClicked(blank: InsuranceExportBlank) {
  await _navigationStore.showObject(IdType.InsuranceExportBlank, blank.id)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogPage, {
    id: "page",
    title: "Bestandsübersicht"
  }, {
    default: _withCtx(() => [
      _withDirectives(_createVNode(SogCard, null, {
        default: _withCtx(() => [
          _createVNode(SogCardActions, { "is-toolbar": true }, {
            default: _withCtx(() => [
              _createVNode(SogCardActionButton, {
                kind: _unref(SogButtonKind).Refresh,
                onClick: p_init
              }, null, 8, ["kind"]),
              _createVNode(SogCardActionButton, {
                kind: _unref(SogButtonKind).Back
              }, null, 8, ["kind"])
            ]),
            _: 1
          }),
          _withDirectives(_createVNode(SogCardContent, null, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode(" Sie haben keine Produkte in Bestand ", -1)
            ]))]),
            _: 1
          }, 512), [
            [_vShow, _items.length===0]
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_items, (item) => {
            return (_openBlock(), _createBlock(SogCardContent, {
              key: item,
              item: item
            }, {
              default: _withCtx(() => [
                _createVNode(StoreItemCardComponent, { item: item }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(SogCardActions, null, {
                      default: _withCtx(() => [
                        _createVNode(SogCardActionButton, {
                          "mdi-icon": "mdi-list-box",
                          tooltip: "Kartenübersicht",
                          onClick: ($event: any) => (onList(item))
                        }, null, 8, ["onClick"])
                      ]),
                      _: 2
                    }, 1536), [
                      [_vShow, isInsurance(item)||isInsuranceExportBlank(item)]
                    ])
                  ]),
                  _: 2
                }, 1032, ["item"])
              ]),
              _: 2
            }, 1032, ["item"]))
          }), 128))
        ]),
        _: 1
      }, 512), [
        [_vShow, !_type.value]
      ]),
      _withDirectives(_createVNode(SogCard, null, {
        default: _withCtx(() => [
          _createVNode(SogCardTitle, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(_storeStore)?.currentItem?.productName), 1)
            ]),
            _: 1
          }),
          _createVNode(SogCardActions, { "is-toolbar": true }, {
            default: _withCtx(() => [
              _createVNode(SogCardActionButton, {
                kind: _unref(SogButtonKind).Back
              }, null, 8, ["kind"])
            ]),
            _: 1
          }),
          _withDirectives(_createVNode(SogCardContent, null, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode(" Sie haben keine Versicherungskarte in Bestand ", -1)
            ]))]),
            _: 1
          }, 512), [
            [_vShow, _insurances.length===0]
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_insurances, (insurance) => {
            return (_openBlock(), _createBlock(SogCardContent, { key: insurance }, {
              default: _withCtx(() => [
                _createVNode(StoreItemInsuranceCardComponent, { insurance: insurance }, null, 8, ["insurance"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 512), [
        [_vShow, _type.value==='insurance']
      ]),
      _withDirectives(_createVNode(SogCard, null, {
        default: _withCtx(() => [
          _createVNode(SogCardTitle, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(_storeStore)?.currentItem?.productName), 1)
            ]),
            _: 1
          }),
          _createVNode(SogCardActions, { "is-toolbar": true }, {
            default: _withCtx(() => [
              _createVNode(SogCardActionButton, {
                kind: _unref(SogButtonKind).Refresh,
                onClick: refresh
              }, null, 8, ["kind"]),
              _createVNode(SogCardActionButton, {
                kind: _unref(SogButtonKind).Back
              }, null, 8, ["kind"])
            ]),
            _: 1
          }),
          _withDirectives(_createVNode(SogCardContent, null, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode(" Sie haben keine Ausfuhrversicherungsformulare in Bestand ", -1)
            ]))]),
            _: 1
          }, 512), [
            [_vShow, _insuranceExportBlanks.length===0]
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_insuranceExportBlanks, (blank) => {
            return (_openBlock(), _createBlock(SogCardContent, { key: blank }, {
              default: _withCtx(() => [
                _createVNode(StoreItemInsuranceExportBlankCardComponent, { "insurance-export-blank": blank }, {
                  default: _withCtx(() => [
                    _createVNode(SogCardActions, null, {
                      default: _withCtx(() => [
                        _createVNode(SogCardActionButton, {
                          "mdi-icon": "mdi-information",
                          onClick: ($event: any) => (onDetailsClicked(blank))
                        }, null, 8, ["onClick"]),
                        _withDirectives(_createVNode(SogCardActionButton, {
                          "mdi-icon": "mdi-pencil-off",
                          tooltip: "als falsche ausgefüllt markieren",
                          onClick: ($event: any) => (onIncorrectlyFilledClicked(blank))
                        }, null, 8, ["onClick"]), [
                          [_vShow, !(blank.status)]
                        ]),
                        _withDirectives(_createVNode(SogCardActionButton, {
                          "mdi-icon": "mdi-pencil",
                          tooltip: "als gültig markieren",
                          onClick: ($event: any) => (onRemoveIncorrectlyFilledClicked(blank))
                        }, null, 8, ["onClick"]), [
                          [_vShow, blank.status===_unref(InsuranceExportBlankStatus).IncorrectlyFilled]
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["insurance-export-blank"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 512), [
        [_vShow, _type.value==='exportblank']
      ])
    ]),
    _: 1
  }))
}
}

})